Revolution.Module.extend({
    NAME: "mde.swiper-stars", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        // _.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        if ($('.bk-stars').length) {
            setTimeout(function(){
                $('.swiper-stars').each(function (index, elem) {
                    var swiperStars = new Swiper('.swiper-stars', {
                        slidesPerView: '1',
                        spaceBetween: 40,
                        centeredSlides: true,
                        loop: true,

                        breakpoints: {
                            // when window width is >= 900px
                            900: {
                            slidesPerView: 3,
                            spaceBetween: 40
                            }
                        },

                        // If we need pagination
                        pagination: {
                            el: $(elem).find('.swiper-pagination'),
                        },

                        // Navigation arrows
                        navigation: {
                            nextEl: $(elem).find('.swiper-button-next'),
                            prevEl: $(elem).find('.swiper-button-prev'),
                        },
                    });
                });
            }, 3000);

            setTimeout(function(){
                $('.swiper-paragraph').each(function (index, elem) {
                    var swiper = new Swiper('.swiper-paragraph', {
                        spaceBetween: 1,
                        nested: true,
                        spaceBetween: 10,
                        loop: true,

                        navigation: {
                            nextEl: '.swiper-button-next-p',
                            prevEl: '.swiper-button-prev-p',
                        },
                    });
                });
            }, 1000);
        }
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
    }
});
